import { useNavigate } from "react-router-dom";
import { seoArticlesList } from "@/mocks/categories";

export default function SEOContentSection() {
  const navigate = useNavigate();

  const mainArticle = seoArticlesList[0];
  const sideArticle1 = seoArticlesList[1];
  const sideArticle2 = seoArticlesList[2];
  const gridArticles = seoArticlesList.slice(3, 12);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Guia Completo
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-4">
            Hoobuy Sheet 2026
            <br />
            <span className="text-accent-500">Artigos & Guias</span>
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Aprenda tudo sobre como usar o hoobuyspreadsheet para encontrar os
            melhores produtos, comparar preços e fazer compras inteligentes.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          <div className="lg:col-span-3">
            <div
              onClick={() => {
                navigate(`/artigo/${mainArticle.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/artigo/${mainArticle.slug}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              role="link"
              tabIndex={0}
              className="group relative bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer h-full"
            >
              <div className="relative w-full h-[320px] overflow-hidden">
                <img
                  src={mainArticle.image}
                  alt={mainArticle.title}
                  title={mainArticle.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block px-2.5 py-1 bg-secondary-500 text-white text-[11px] font-semibold rounded-full mb-3">
                    {mainArticle.tag}
                  </span>
                  <h3 className="text-white text-xl md:text-2xl font-bold font-heading leading-snug">
                    {mainArticle.title}
                  </h3>
                  <p className="text-white/70 text-sm mt-2 line-clamp-2">
                    {mainArticle.excerpt}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-5">
            <div
              onClick={() => {
                navigate(`/artigo/${sideArticle1.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/artigo/${sideArticle1.slug}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              role="link"
              tabIndex={0}
              className="group relative bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex-1 min-h-[152px]"
            >
              <div className="flex h-full">
                <div className="w-[45%] relative overflow-hidden">
                  <img
                    src={sideArticle1.image}
                    alt={sideArticle1.title}
                    title={sideArticle1.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="w-[55%] p-5 flex flex-col justify-center">
                  <span className="text-accent-500 text-xs font-semibold tracking-wide uppercase mb-1">
                    {sideArticle1.tag}
                  </span>
                  <h3 className="text-base font-bold text-foreground-900 font-heading leading-snug mb-1">
                    {sideArticle1.title}
                  </h3>
                  <p className="text-foreground-400 text-sm line-clamp-2">
                    {sideArticle1.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-accent-600 text-sm font-medium mt-2">
                    Ler artigo
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>

            <div
              onClick={() => {
                navigate(`/artigo/${sideArticle2.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/artigo/${sideArticle2.slug}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              role="link"
              tabIndex={0}
              className="group relative bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer flex-1 min-h-[152px]"
            >
              <div className="flex h-full">
                <div className="w-[45%] relative overflow-hidden">
                  <img
                    src={sideArticle2.image}
                    alt={sideArticle2.title}
                    title={sideArticle2.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="w-[55%] p-5 flex flex-col justify-center">
                  <span className="text-secondary-500 text-xs font-semibold tracking-wide uppercase mb-1">
                    {sideArticle2.tag}
                  </span>
                  <h3 className="text-base font-bold text-foreground-900 font-heading leading-snug mb-1">
                    {sideArticle2.title}
                  </h3>
                  <p className="text-foreground-400 text-sm line-clamp-2">
                    {sideArticle2.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-secondary-600 text-sm font-medium mt-2">
                    Ler artigo
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {gridArticles.map((article) => (
            <div
              key={article.slug}
              onClick={() => {
                navigate(`/artigo/${article.slug}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  navigate(`/artigo/${article.slug}`);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }
              }}
              role="link"
              tabIndex={0}
              className="group relative bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className={`inline-block px-2.5 py-0.5 text-white text-[11px] font-semibold rounded-full ${
                    article.tagColor === "accent" ? "bg-accent-500" : "bg-secondary-500"
                  } mb-2`}>
                    {article.tag}
                  </span>
                  <h3 className="text-white text-sm font-bold font-heading leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-400 text-xs leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-foreground-500 text-xs font-medium hover:text-accent-600 transition-colors">
                  Ler artigo completo
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            type="button"
            onClick={() => {
              navigate(`/artigo/guia-completo-hoobuyspreadsheet`);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-white border border-background-300 text-foreground-800 text-sm font-semibold rounded-full hover:bg-background-50 hover:border-foreground-300 transition-all whitespace-nowrap cursor-pointer"
          >
            Ver Todos os Artigos
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}